(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('DashboardService', DashboardService);

    DashboardService.$inject = ['$http', 'DateUtils'];

    function DashboardService($http, DateUtils) {
        var service = {};

        service.loaddata = function (callback) {

            $http.get('api/dashboard/dashboarddata').then(function (response) {
                callback(response.data);
            });
        };


        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('DashboardServiceGeo', DashboardServiceGeo);

    DashboardServiceGeo.$inject = ['$resource'];

    function DashboardServiceGeo($resource) {
        var service = $resource('/api/dashboard/dashboarddata/:geofenceId', {
            // searchvalue : '@id'
        }, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });

        return service;
    }

})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CaseCountByPriority', CaseCountByPriority);

    CaseCountByPriority.$inject = ['$http'];

    function CaseCountByPriority($http) {
        var service = {};

        service.get = function (callback) {
            $http.get('api/dashboard/case-count-by-priority').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('CaseCountByPriorityGeo', CaseCountByPriorityGeo);

    CaseCountByPriorityGeo.$inject = ['$resource'];

    function CaseCountByPriorityGeo($resource) {
        var service = $resource('/api/dashboard/case-count-by-priority/:geofenceId', {
            // searchvalue : '@id'
        }, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });

        return service;
    }

})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CaseCountByStatus', CaseCountByStatus);

    CaseCountByStatus.$inject = ['$http'];

    function CaseCountByStatus($http) {
        var service = {};

        service.get = function (callback) {
            $http.get('api/dashboard/case-count-by-status').then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('CaseCountByStatusGeo', CaseCountByStatusGeo);

    CaseCountByStatusGeo.$inject = ['$resource'];

    function CaseCountByStatusGeo($resource) {
        var service = $resource('/api/dashboard/case-count-by-status/:geofenceId', {
            // searchvalue : '@id'
        }, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('UserListAndDistanceGeo', UserListAndDistanceGeo);

    UserListAndDistanceGeo.$inject = ['$resource'];

    function UserListAndDistanceGeo($resource) {
        var service = $resource('api/dashboard/userlist/:geofenceId', { geofenceId: '@geofenceId' }, {}, {
            'query': { method: 'GET', isArray: true },
        });

        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('LinkService', LinkService);

    LinkService.$inject = ['$http', 'DateUtils'];

    function LinkService($http, DateUtils) {
        var service = {};

        service.loaddata = function (callback) {

            $http.get('api/dashboard/dashboardlinkdata').then(function (response) {
                callback(response.data);
            });
        };


        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('UserListAndDistance', UserListAndDistance);

    UserListAndDistance.$inject = ['$resource'];

    function UserListAndDistance($resource) {
        var service = $resource('api/dashboard/userlist', {}, {
            'query': { method: 'GET', isArray: true },
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('UserListAndDistanceSearch', UserListAndDistanceSearch);

    UserListAndDistanceSearch.$inject = ['$resource'];

    function UserListAndDistanceSearch($resource) {
        var service = $resource('api/dashboard/userlist/:login', { login: '@login' }, {}, {
            'query': { method: 'GET', isArray: true },
        });

        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('TaskStatusById', TaskStatusById);

    TaskStatusById.$inject = ['$http'];

    function TaskStatusById($http) {
        var service = {};

        service.post = function (payload, callback) {
            $http.post('api/rollout/task-status', payload).then(function (response) {
                callback(response.data);
            });
        };

        service.getworkOrderByRoute = function (id, callback) {
            $http.get('api/tr-workorders/route/' + id).then(function (response) {
                callback(response.data);
            }, function (err) {
                callback(err);
            });
        };


        return service;
    }
})();

//dashboard rollout temp services
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('WorkOrderStats', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (name, callback) {
            $http.get('api/workorderstats/' + name).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('WorkFlowListByWorkOrderID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/workorderworkflows/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();

(function () {
    'use strict';

    angular.module('trakeyeApp').factory('AssetsByWorkFlowID', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        service.get = function (id, callback) {
            $http.get('api/assetsbywf/' + id).then(function (response) {
                callback(response.data);
            });
        };

        return service;
    }]);
})();
(function () {
    'use strict';

    angular.module('trakeyeApp').factory('getIncidentData', ['$rootScope', '$http', function ($rootScope, $http) {

        var service = {};
        // http://127.0.0.1:8080/api/dashboard/packages
        service.getPackages = function (callback) {
            $http.get('api/dashboard/packages').then(function (response) {
                callback(response);
            });
        };
        // http://127.0.0.1:8080/api/dashboard//statesBypackges/PKG-4
        service.getStatesByPackage = function (packageId, callback) {
            $http.get('api/dashboard/statesBypackges/' + packageId).then(function (response) {
                callback(response);
            });
        };
        // this gives list of business areas /api/dashboard/business-area/KARNATAKA/PKG-4
        service.getBusinessArea = function (stateId,packageId, callback) {
            $http.get('api/dashboard/business-area/' + stateId + '/' + packageId).then(function (response) {
                callback(response);
            });
        };
        // this gives list of operational areas by business area id
        service.getOperationalArea = function (id, callback) {
            $http.get('api/dashboard/oaNamesByBaId/' + id).then(function (response) {
                callback(response);
            });
        };
        // this gives list of districts by operational area id
        service.getDistrict = function (opId, callback) {
            $http.get('api/master-geofenceByOaId/' + opId).then(function (response) {
                callback(response);
            });
        };
        // this gives list of blocks by master geofence id
        service.getBlocks = function (dId, callback) {
            $http.get('api/mini-geofences-by-masterGefenceId/' + dId).then(function (response) {
                callback(response);
            });
        };

        service.getGeofenceIncidents = function (fromDate, toDate, opId, baId, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-incidents-data/' + opId + '/' + fromDate + '/' + toDate + '/' + baId + '/' + amcValue).then(function (response) {
                callback(response);
            });
        };
        service.getIncidents = function (baId, fromDate, toDate, oaId, amcStatus, callback) {
            var oaValue = oaId ? oaId : "";
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-incidents-data/' + baId + '/' + fromDate + '/' + toDate + '/' + oaValue + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };
        // case-count-by-priority-incidents-package-data/PKG-4/1735669800000/1765784646301
        service.getIncidentsbyPackage = function (fromDate, toDate, packageId, amcStatus, callback) {
            var pkgValue = packageId ? packageId : "";
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-incidents-package-data/' + pkgValue + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };
        // case-count-by-priority-incidents-package-data/PKG-4/KARNATAKA/1735669800000/1765784646301
        service.getIncidentsbyPackageAndState = function (packageId, stateId, fromDate, toDate, amcStatus, callback) {
            var pkgValue = packageId ? packageId : "";
            var stateValue = stateId ? stateId : "";
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-incidents-package-data/' + pkgValue + '/' + stateValue + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };
        service.getStatus = function (baId, fromDate, toDate, oaId, amcStatus, type, callback) {
            if (typeof type === 'function') {
                callback = type;
                type = null;
            }
            var oaValue = oaId ? oaId : "";
            var amcValue = amcStatus ? amcStatus : "";
            var typeValue = type ? type : (oaValue ? 'OA' : 'BA');
            $http.get('api/dashboard/case-count-by-status-incidents-data/' + baId + '/' + fromDate + '/' + toDate + '/' + oaValue + '/' + amcValue + '?type=' + typeValue)
                .then(function (response) {
                    callback(response);
                });

        };
        service.getGeofenceIncidents = function (baId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-incidents-data/' + baId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });

        };
        service.getGeofenceIncident = function (baId, fromDate, toDate, amcStatus, type, callback) {
            if (typeof type === 'function') {
                callback = type;
                type = null;
            }
            var amcValue = amcStatus ? amcStatus : "";
            var typeValue = type ? type : 'BA';
            $http.get('api/dashboard/case-count-by-status-incidents-data/' + baId + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + typeValue)
                .then(function (response) {
                    callback(response);
                });
        };
        service.getIncidentsData = function (dId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority/' + dId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };

        service.getStatusData = function (dId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-status/' + dId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };

        // /case-count-by-status-incidents-package-data/{pckg}/{startTime}/{endTime}
        service.getStatusbyPackage = function (fromDate, toDate, packageId, amcStatus, type, callback) {
            if (typeof type === 'function') {
                callback = type;
                type = null;
            }
            var pkgValue = packageId ? packageId : "";
            var amcValue = amcStatus ? amcStatus : "";
            var typeValue = type ? type : 'PACKAGE';
            var url = 'api/dashboard/case-count-by-status-incidents-package-data/' + pkgValue + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + typeValue;
            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getStatusbyPackage error:', error);
                });
        };

        service.getStatusbyPackageAndState = function (packageId, stateId, fromDate, toDate, amcStatus, type, callback) {
            if (typeof type === 'function') {
                callback = type;
                type = null;
            }
            var pkgValue = packageId ? packageId : "";
            var stateValue = stateId ? stateId : "";
            var amcValue = amcStatus ? amcStatus : "";
            var typeValue = type ? type : (stateValue ? 'STATE' : 'PACKAGE');
            var url = 'api/dashboard/case-count-by-status-incidents-package-data/' + pkgValue + '/' + stateValue + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + typeValue;
            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getStatusbyPackageAndState error:', error);
                });
        };

        service.getIncidentsDataBlock = function (bId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-MiniGeoId/' + bId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };

        service.getStatusDataBlock = function (bId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-status-miniGeoId/' + bId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };
        // api/dashboard/case-count-by-priority-gp/{GPID}/{fromDate}/{toDate}
        service.getIncidentsDataGP = function (gpId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-priority-gp/' + gpId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };
        // /api/dashboard/case-count-by-status-gp/19463297/1763145000000/1766387318763
        service.getStatusDataGP = function (gpId, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            $http.get('api/dashboard/case-count-by-status-gp/' + gpId + '/' + fromDate + '/' + toDate + '/' + amcValue)
                .then(function (response) {
                    callback(response);
                });
        };
        // sla-status-case-count-package-state/PKG-4/KARNATAKA/1704047400000/1765784646301?type=PACKAGE
        // or sla-status-case-count-package-state/PKG-4/1704047400000/1765784646301?type=PACKAGE (without state)
        service.getSLAStatusDataByPackageAndState = function (packageId, stateId, type, fromDate, toDate, amcStatus, callback) {
            var pkgValue = packageId ? packageId : '';
            var stateValue = stateId ? stateId : '';
            var amcValue = amcStatus ? amcStatus : '';
            
            // Build URL - include state in path if provided
            var url;
            if (stateValue) {
                url = 'api/dashboard/sla-status-case-count-package-state/'  + stateValue + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + type;
            } else {
                url = 'api/dashboard/sla-status-case-count-package-state/' + pkgValue + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + type;
            }
            
            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getSLAStatusDataByPackageAndState API error:', error);
                    callback(null);
                });
        };

        // http://127.0.0.1:8080/api/dashboard/sla-status-case-count/1211202501?type=BA
        service.getSLAStatusData = function (id, type, fromDate, toDate, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            var url = 'api/dashboard/sla-status-case-count/' + id + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + type;

            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getSLAStatusData API error:', error);
                    callback(null);
                });
        };
        // dashboard/roleCountsByAuthority/KARNATAKA?type=STATE
        service.getRoleCountsByAuthority = function (name, type, callback) {
            var url = 'api/dashboard/roleCountsByAuthority/' + name + '?type=' + type;
            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getRoleCountsByAuthority API error:', error);
                    callback(null);
                });
        };

        // /api/dashboard/gpTotalCount/22667329/1763145000000/1766387318763
        service.getGPTotalCount = function (id, type, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : '';
            var url = 'api/dashboard/gpTotalCount/' + id + '/' + amcValue + '?type=' + type + '&assetType=GP';
            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getGPTotalCount API error:', error);
                    callback(null);
                });
        };

        // POST request to get GP data by Block ID
        service.getGPByBlock = function (blockId, callback) {
            var payload = {
                lastAssetId: null,
                geofences: [Number(blockId)],
                assetTypes: ["GP", "ONT"]
            };
            var url = 'api/assets-group-by-geofences-db?';
            $http.post(url, payload)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getGPByBlock API error:', error);
                    callback(null);
                });
        };
        // /api/dashboard/gpListByBlock/19781977 
        // this is there to get GP List by Block ID
        service.getGPListByBlock = function (blockId, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : "";
            var url = 'api/dashboard/gpListByBlock/' + blockId + '/' + amcValue;
            $http.get(url)
                .then(function (response) { 
                    callback(response);
                }, function (error) {
                    console.error('getGPListByBlock API error:', error);
                    callback(null);
                });
        };
        // http://127.0.0.1:8080/api/dashboard/day-wise-incidentCouts/22667329/1735669800000/1765784646301?type=MINI
        service.getDayWiseIncidentCounts = function (id, fromDate, toDate, type, amcStatus, callback) {
            var amcValue = amcStatus ? amcStatus : '';
            var url = 'api/dashboard/day-wise-incidentCouts/' + id + '/' + fromDate + '/' + toDate + '/' + amcValue + '?type=' + type;
            $http.get(url)
                .then(function (response) {
                    callback(response);
                }, function (error) {
                    console.error('getDayWiseIncidentCounts API error:', error);
                    callback(null);
                });
        };
        return service;
    }]);
})();
